module.exports = __webpack_public_path__ + "img/desalination-plant.3624e3e8.svg";